<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div
    class="rfq-create-form"
    [ngClass]="{
      'full-width-container1': !showDetailSection,
      'half-width-container1': showDetailSection
    }"
  >
    <div class="rfq-create-form-title">
      <div
        style="
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          padding: 10px;
          justify-content: flex-end;
          background-color: white;
        "
      >
        <!-- <button class="right-button" (click)="rfqActions('download')">Download file</button>
                <button class="right-button" (click)="rfqActions('decline')"
                [disabled]="headerData?.docStatus == 'Declined'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined'}">Decline</button>
                <button class="right-button" (click)="rfqActions('acknowledge')"
                [disabled]="headerData?.docStatus == 'Acknowledged'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Acknowledged'}">Acknowledge</button> -->

        <button
          class="right-button"
          (click)="toggleShowHeaderDetails({ checked: !showDetailSection })"
        >
          {{ showDetailSection ? "Hide RFQ Details" : "Show RFQ Details" }}
        </button>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 10px;
          margin-bottom: 5px;
        "
      >
        <div id="createquotation">Create Quotation</div>

        <!-- <div style="float: right; margin-left: 16px;border:2px solid red"> -->
        <!-- <div style="display: flex;justify-content: space-between;align-items:center;padding:0px 15px;"
                [ngClass]="{ 'fullscreenbutton': !showDetailSection, 'halfscreenbutton': showDetailSection }">
                    <button mat-button color="primary"
                    style="font-size:18px; padding-left: 30px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
                    
                    (click)="submit(true)">Save as Draft</button>

                    <button mat-button color="primary"
                        style="font-size:18px; padding-left: 25px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
                        
                        (click)="submit(false)">Submit</button>

                    <button mat-button color="primary"
                        style="font-size:18px; padding-left: 25px; padding-right: 25px; padding-top: 24px; padding-bottom: 24px; background-color: #f99c30 !important;"
                        (click)="back()">Back</button>

                </div> -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0px 15px;
          "
          [ngClass]="{
            fullscreenbutton: !showDetailSection,
            halfscreenbutton: showDetailSection
          }"
        >
          <!-- <button mat-button color="primary"  
                    style="font-size:18px; padding-left: 32px; padding-right: 32px; padding-top: 24px; padding-bottom: 24px;"
                    (click)="save()"><mat-icon>navigate_before</mat-icon> Back</button> -->
          <button
            mat-button
            color="primary"
            style="
              font-size: 18px;
              padding-left: 32px;
              padding-right: 32px;
              padding-top: 24px;
              padding-bottom: 24px;
            "
            (click)="close(true)"
          >
            Close<mat-icon>navigate_next</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div
      class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4"
      style="width: 100%"
    >
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content class="ship-fscoll hgt ship-pr-sec">
          <nav mat-tab-nav-bar class="tagGroup">
            <a
              mat-tab-link
              *ngFor="let tabItem of tabs; let idx = index"
              [class.active-link]="currentTab === tabItem.route"
              class="teb_icon"
              (click)="selectMatTabLink(tabItem)"
            >
              <span id="navstepstext">{{ tabItem.label }}</span>
            </a>
          </nav>

          <div class="mat-tab-body-content pos-relative">
            <div>
              <form [formGroup]="paymentFormGroup">
                <div style="display: flex; flex-direction: column">
                  <div class="payment-header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form3')"
                    >
                      My Payment Terms
                    </span>

                    <div>
                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label
                            >Payment Terms<span
                              class="required-star"
                              style="color: red; margin-left: 2px"
                              >*</span
                            ></mat-label
                          >
                          <mat-select
                            formControlName="paymentTermsId"
                            [value]="paymentTermsId"
                            placeholder=""
                          >
                            <mat-option
                              *ngFor="let item of paymentTermsData"
                              [value]="item.id"
                              >{{ item.name }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <!-- <div class="form-item-row">
                                            <mat-form-field class="full-width" color="accent">
                                                <mat-label>Terms and Conditions</mat-label>
                                            
                                                <textarea matInput placeholder="Terms and Conditions" formControlName="termsAndConditions" ></textarea>

                                            </mat-form-field>
                                            
                                        </div> -->

                      <div class="form-item-row">
                        <div class="full-width" style="margin-bottom: 30px">
                          <!-- <label style="margin-bottom: 10px;font-size: 17px;">Terms and Conditions
                                                    <span>
                                                        <button mat-icon-button matTooltip="Preview Attachments" matTooltipPosition="below" (click)="togglePaymentTermsAndConditionsAttachment(true)" style="padding-top:10px">
                                                            <mat-icon>visibility</mat-icon>
                                                        </button>
                                                    </span>
                                                </label> -->
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              margin-bottom: 10px;
                            "
                          >
                            <label style="font-size: 17px; margin: 0"
                              >Terms and Conditions</label
                            >
                            <button
                              *ngIf="
                                paymentTermsAndConditionAttachmentUrl?.trim()
                              "
                              mat-icon-button
                              matTooltip="Preview Attachments"
                              matTooltipPosition="below"
                              (click)="
                                togglePaymentTermsAndConditionsAttachment(true)
                              "
                              style="margin-left: 8px"
                            >
                              <mat-icon>visibility</mat-icon>
                            </button>
                          </div>
                          <div
                            style="
                              max-height: 180px;
                              overflow-y: auto;
                              border-bottom: 1px solid rgba(0, 0, 0, 0.45);
                              font-size: 15px;
                              background-color: whitesmoke;
                              border-radius: 4px;
                              padding: 20px;
                            "
                          >
                            <div
                              class="terms-container"
                              [innerHTML]="paymenttermsconditioncolumn"
                              style="
                                white-space: pre-wrap;
                                word-wrap: break-word;
                              "
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label
                            >Currency Instructions<span
                              class="required-star"
                              style="color: red; margin-left: 2px"
                              >*</span
                            ></mat-label
                          >

                          <textarea
                            matInput
                            placeholder=""
                            formControlName="currencyInstructions"
                          ></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="payment-header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        padding-bottom: 18px;
                        margin-bottom: 12px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form5')"
                    >
                      Buyer Payment Terms
                    </span>

                    <div>
                      <div class="form-item-row" style="margin-bottom: 10px">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Billing Address</mat-label>

                          <textarea
                            matInput
                            placeholder="Billing Address"
                            formControlName="billingAddress"
                            readonly
                          >
                          </textarea>
                        </mat-form-field>
                      </div>

                      <div class="form-item-row" style="margin-bottom: 10px">
                        <!-- <div class="full-width">
                                                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                                                        <label style="font-size: 17px; margin: 0;">Tax Status</label>
                                        
                                                    </div>
                                                    <div *ngIf="this.buyerFormGroup.get('taxStatus')?.value?.length" class="table-container">
                                                        <table class="mat-elevation-z2">
                                                        <thead>
                                                            <tr>
                                                            <th style="width: 50%;">Applicable TAX</th>
                                                            <th style="width: 50%;">Tax Percentage</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let tax of this.buyerFormGroup.get('taxStatus')?.value; let i = index">
                                                            <td>{{ tax.name }}</td>
                                                            <td>{{ tax.percentage }}%</td>
                                                            <td class="actions-cell">
                                                                <button mat-icon-button color="accent" (click)="onEditTax(i)">
                                                                <mat-icon style="color: #f99c30;">edit</mat-icon>
                                                                </button>
                                                            </td>
                                                            </tr>
                                                        </tbody>
                                                        </table> 
                                                    </div>
                                                     <div style="max-height: 140px;overflow-y: auto;border-bottom:1px solid rgba(0, 0, 0, .45);font-size:15px;background-color: whitesmoke;border-radius: 4px;">
                                                        <table
                                                        *ngIf="this.buyerFormGroup.get('taxStatus')?.value?.length"
                                                        class="mat-elevation-z2 custom-tax-table"
                                                        >
                                                        <thead>
                                                            <tr>
                                                            <th>Applicable TAX</th>
                                                            <th>Tax Percentage</th>
                    
                                                            </tr>
                                                        </thead>
                                                        
                                                        <tbody>
                                                            <tr>
                                                            <td style="padding: 0;" colspan="3">
                                                                
                                                                <div style="max-height: 100px; overflow-y: auto;">
                                                                <table style="width: 100%;">
                                                                    <tbody>
                                                                    <tr *ngFor="let tax of this.buyerFormGroup.get('taxStatus')?.value; let i = index">
                                                                        <td>{{ tax.name }}</td>
                                                                        <td>{{ tax.percentage }}%</td>
                                                                        
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </td>
                                                        </tr>
                                                        </tbody>
                                                        <div class="table-body-scroll">
                                                            <table class="custom-tax-table">
                                                            <tbody>
                                                                <tr *ngFor="let tax of buyerFormGroup.get('taxStatus')?.value; let i = index">
                                                                <td>{{ tax.name }}</td>
                                                                <td>{{ tax.percentage }}%</td>
                                                                
                                                                </tr>
                                                            </tbody>
                                                            </table>
                                                        </div>
                                                        </table>
                                                    </div> 
                                                </div> -->
                        <!-- <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Tax Status</mat-label>
                                                
                                                    <textarea matInput placeholder="Tax Status" formControlName="taxStatus" readonly></textarea>
                                                   
                                                    
                                                </mat-form-field> -->
                        <div class="readonly-wrapper">
                          <mat-form-field class="full-width" color="accent">
                            <mat-label>Applicable Tax Profile</mat-label>

                            <mat-select
                              formControlName="taxStatus"
                              placeholder=""
                            >
                              <mat-option
                                *ngFor="let item of taxStatusData"
                                [value]="item.taxId"
                              >
                                {{ item.country?.name }} -
                                {{ item.taxType }} ({{ item.regionName }}) -
                                {{ item.taxNumber }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div class="readonly-overlay"></div>
                        </div>
                      </div>

                      <div
                        class="form-item-row"
                        style="margin-bottom: 30px; margin-top: 30px"
                      >
                        <!-- <mat-form-field class="full-width" color="accent">
                                                    <mat-label>Terms and Conditions</mat-label>
                                                
                                                    <textarea matInput placeholder="Terms and Conditions" formControlName="buyerTermsAndConditions" readonly></textarea>
        
                                                </mat-form-field> -->
                        <div class="full-width" style="margin-bottom: 10px">
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              margin-bottom: 10px;
                            "
                          >
                            <label style="font-size: 17px; margin: 0"
                              >Terms and Conditions</label
                            >
                            <button
                              *ngIf="
                                buyerPaymentTermsAndConditionAttachmentUrl?.trim()
                              "
                              mat-icon-button
                              matTooltip="Preview Attachments"
                              matTooltipPosition="below"
                              (click)="
                                toggleBuyerPaymentTermsAndConditionsAttachment(
                                  true
                                )
                              "
                              style="margin-left: 8px"
                            >
                              <mat-icon>visibility</mat-icon>
                            </button>
                          </div>
                          <div
                            style="
                              max-height: 140px;
                              overflow-y: auto;
                              border-bottom: 1px solid rgba(0, 0, 0, 0.45);
                              font-size: 15px;
                              background-color: whitesmoke;
                              border-radius: 4px;
                              padding: 20px;
                            "
                          >
                            <div
                              class="terms-container"
                              [innerHTML]="
                                paymentFormGroup.get('buyerTermsAndConditions')
                                  ?.value
                              "
                              style="
                                white-space: pre-wrap;
                                word-wrap: break-word;
                              "
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Payment Terms</mat-label>

                          <textarea
                            matInput
                            placeholder="Payment Terms"
                            formControlName="buyerPaymentTerms"
                            readonly
                          ></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div
    class="siderfqbar"
    [ngClass]="{
      'full-width-container2': !showDetailSection,
      'half-width-container2': showDetailSection
    }"
    style="margin-right: 10px; overflow: auto"
  >
    <div class="siderfqbar-title">
      <div class="siderfqbar-title-text">RFQ Details</div>
    </div>

    <div class="siderfqbar-content">
      <!-- <div style="display: flex; flex-wrap: wrap; gap: 12px; padding: 10px; justify-content: flex-start;">
                <button class="right-button" (click)="rfqActions('download')">Download file</button>
                <button class="right-button" (click)="rfqActions('decline')"
                [disabled]="headerData?.docStatus == 'Declined'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Declined'}">Decline</button>
                <button class="right-button" (click)="rfqActions('acknowledge')"
                [disabled]="headerData?.docStatus == 'Acknowledged'"
                [ngClass]="{'disabled-button': headerData?.docStatus == 'Acknowledged'}">Acknowledge</button>
            </div> -->

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
          >Buyer Company Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Buyer Name : {{ headerData?.buyerCompanyName }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.companyEmailId }}
            </li>
            <li class="list-group-item">
              Phone : {{ headerData?.companyPhoneNumber }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.companyFax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.companyAddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">Contact : {{ headerData?.contact }}</li>
            <li class="list-group-item">
              Job Title : {{ headerData?.jobTitle }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.emailId }}
            </li>
            <li class="list-group-item">Phone : {{ headerData?.phone }}</li>
            <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
            <li class="list-group-item">Address : {{ headerData?.address }}</li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          RFQ Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              RFQ Ref Number : {{ headerData?.rfqRefNumber }}
            </li>
            <li class="list-group-item">
              RFQ Date : {{ headerData?.rfqDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Quote by Date :
              {{ headerData?.quoteByDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Document Number : {{ headerData?.docNumber }}
            </li>
            <li class="list-group-item">
              Tracking Number : {{ headerData?.trackingNumber }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Vessel Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Vessel Name : {{ headerData?.vessel?.vesselName }}
            </li>
            <li class="list-group-item">
              Vessel IMO Number : {{ headerData?.vessel?.imoNumber }}
            </li>
            <li class="list-group-item">
              Vessel Type : {{ headerData?.vessel?.typeOfVessel }}
            </li>
            <li class="list-group-item">
              Class : {{ headerData?.vessel?.class }}
            </li>
            <li class="list-group-item">
                Hull Number : {{ headerData?.vessel?.hullNumber }}
              </li>
              <li class="list-group-item">
                Yard Name : {{ headerData?.vessel?.yardName }}
              </li>
              <li class="list-group-item">
                Year Built : {{ headerData?.vessel?.yearBuilt }}
              </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Port Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Port Name : {{ headerData?.portName }}
            </li>
            <li class="list-group-item">
              Port Code : {{ headerData?.portCode }}
            </li>
            <li class="list-group-item">
              Vessel ETA : {{ headerData?.vesselEta | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Vessel ETD : {{ headerData?.vesselEtd | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Vessel ETB : {{ headerData?.vesselEtb | date : "dd/MM/yyyy" }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Port Agent Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Port Agency Name : {{ headerData?.portAgentNumber }}
            </li>
            <li class="list-group-item">
              Port Agent Name : {{ headerData?.portAgentNumber }}
            </li>
            <li class="list-group-item">
              Port Agent Phone Number : {{ headerData?.rfqPortAgentphone }}
            </li>
            <li class="list-group-item">
              Port Agent Contact : {{ headerData?.rfqPortAgentContact }}
            </li>
            <li class="list-group-item">
              Port Agent Fax : {{ headerData?.rfqPortAgentfax }}
            </li>
            <li class="list-group-item">
              Port Agent Email Id : {{ headerData?.rfqPortAgentemailId }}
            </li>
            <li class="list-group-item">
              Address : {{ headerData?.rfqPortAgentaddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Freight Forwarder Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Freight Forwarder Company Name :
              {{ headerData?.freightForwarderId }}
            </li>
            <li class="list-group-item">PIC : {{ headerData?.rffdPic }}</li>
            <li class="list-group-item">
              Job Title : {{ headerData?.rffdjobTitle }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.rffdemailId }}
            </li>
            <li class="list-group-item">Phone : {{ headerData?.rffdphone }}</li>
            <li class="list-group-item">Fax : {{ headerData?.rffdfax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.rffdaddress }}
            </li>
            <li class="list-group-item">
              Packaging : {{ headerData?.rffdpackaging }}
            </li>
            <li class="list-group-item">
              Mode of Transport : {{ headerData?.rffdmodeOfTransport }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Delivery Details
        </span>

        <div>
          <!-- <ul class="list-group">
            <li class="list-group-item">Request Delivery Date : -</li>
            <li class="list-group-item">Lead Time In Delivery : -</li>
            <li class="list-group-item">Contact : -</li>
            <li class="list-group-item">Email Id : -</li>
            <li class="list-group-item">Phone : -</li>
            <li class="list-group-item">Fax : -</li>
            <li class="list-group-item">Delivery Terms And Conditions : -</li>
            <li class="list-group-item">Delivery Address : -</li>
            <li class="list-group-item">Mode of Transport : -</li>
          </ul> -->
          <ul class="list-group">
            <li class="list-group-item">
              Request Delivery Date :
              {{ headerData?.requestDeliveryDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Lead Time In Delivery : {{ headerData?.leadTimeInDelivery }}
            </li>
            <li class="list-group-item">
              Contact : {{ headerData?.Deliverycontact }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.Deliveryemail }}
            </li>
            <li class="list-group-item">
              Phone : {{ headerData?.Deliverycontact }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.Deliveryfax }}</li>
            <li class="list-group-item">
              Delivery Terms And Conditions :
              {{ headerData?.deliveryTermsAndConditions }}
            </li>
            <li class="list-group-item">
              Delivery Address : {{ headerData?.deliveryAddress }}
            </li>
            <li class="list-group-item">Mode of Transport : {{ headerData?.modeOfTransport || 'N/A' }}</li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Invoice Address
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Buyer Name : {{ headerData?.buyerCompanyName }}
            </li>
            <li class="list-group-item">Email Id : {{ headerData?.emailId }}</li>
            <li class="list-group-item">
              Phone : {{ headerData?.companyPhoneNumber }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.invoiceAddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <!-- <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Payment Terms
        </span>

        <div>
          <p>{{ headerData?.buyerPaymentTerms }}</p>
        </div> -->

        <div class="header-title">Buyer Payment Terms</div>
        <div class="header-content">
          {{ headerData?.buyerPaymentTerms }}
        </div>
      </div>

      <div class="header-form">
        <!-- <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Terms & Conditions
        </span>

        <div>
          <p>{{ headerData?.buyerTermsAndConditions }}</p>
        </div> -->

        <div class="header-title">Buyer Terms & Conditions</div>
        <div class="header-content pre-line">
          {{ headerData?.buyerTermsAndCondition }}
        </div>
      </div>

      <!-- <div class="button-container">
                <button type="submit" class="save-button" (click)="saveVessel()">
                  <mat-icon>save</mat-icon>
                </button>
                <button type="button" class="close-button" (click)="toggleNewVessel(false)">
                  <mat-icon>cancel</mat-icon>
                </button>
              </div> -->
    </div>
  </div>
</div>

<!-- <div class="namemodal" *ngIf="showConfirmationDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to submit this quotation?<br>Once submitted, changes cannot be made.</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(false)">OK</button>
                    <button mat-stroked-button (click)="cancel()">Cancel</button>
                </div>
            </div>

        </div>
    </div>

   
    <div class="namemodal" *ngIf="showCloseDialogue">
        <div class="modalContent">
            <div class="p-6 text-center">
                <div class="flex justify-center mb-4">
                    <div class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center">
                        <mat-icon class="text-orange-600"
                            style="font-size: 40px;  height:100%; width:100%;">warning</mat-icon>
                    </div>
                </div>
                <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
                <p class="mb-6">Are you sure you want to save this quotation as draft?</p>
                <div class="flex justify-center gap-4">
                    <button mat-raised-button color="primary" (click)="save(true)">Save as draft</button>
                    <button mat-stroked-button (click)="cancel()">Cancel</button>
                </div>
            </div>
    
        </div>
    </div> -->

<!-- Popup for confirmation -->
<div class="namemodal" *ngIf="showCloseDialogue">
  <div class="modalContent">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div
          class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
        >
          <mat-icon
            class="text-orange-600"
            style="font-size: 40px; height: 100%; width: 100%"
            >warning</mat-icon
          >
        </div>
      </div>
      <!-- <h2 class="text-xl font-bold mb-2">You want to save this as draft?</h2> -->
      <p class="mb-6">You want to save this as draft?</p>
      <div class="flex justify-center gap-4">
        <button
          mat-raised-button
          color="primary"
          (click)="save(true)"
          style="margin-right: 5px"
        >
          YES
        </button>
        <button mat-stroked-button (click)="cancel()" style="margin-left: 5px">
          NO
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="blur"
  *ngIf="paymentTermsAndConditionsSection"
  (click)="togglePaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="paymentTermsAndConditionsSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="togglePaymentTermsAndConditionsAttachment(false)"
    >
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <pdf-viewer
          [src]="paymentTermsAndConditionAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <img
          [src]="paymentTermsAndConditionAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
  </div>
</div>

<div
  class="blur"
  *ngIf="buyerPaymentTermsAndConditionsSection"
  (click)="toggleBuyerPaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="buyerPaymentTermsAndConditionsSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="toggleBuyerPaymentTermsAndConditionsAttachment(false)"
    >
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <!-- <button class="carousel-control prev" (click)="prevSlide()">
        &#10094;
    </button> -->

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <pdf-viewer
          [src]="buyerPaymentTermsAndConditionAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(buyerPaymentTermsAndConditionAttachmentUrl)"
      >
        <img
          [src]="buyerPaymentTermsAndConditionAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <!-- <button class="carousel-control next" (click)="nextSlide()">
        &#10095;
    </button> -->
  </div>
</div>

<!-- Notification Overlay to Dim the Background -->
<div *ngIf="showNotification" class="notification-overlay"></div>

<!-- Custom Notification for Missing Fields -->
<div
  *ngIf="showNotification"
  class="notification-popup"
  [ngClass]="{
    'error-notification': notificationType === 'error',
    'info-notification': notificationType === 'info',
    show: showNotification,
    hide: !showNotification
  }"
>
  <div class="notification-content">
    <div class="flex justify-center mb-4">
      <div
        class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
      >
        <mat-icon
          class="text-orange-600"
          style="font-size: 75px; height: 100%; width: 100%"
          >warning</mat-icon
        >
      </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div>
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div>
